var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"title":"Se connecter en tant que cet utilisateur","icon-left":"lock-outline"},on:{"click":_vm.onImpersonate}})}
var staticRenderFns = []

export { render, staticRenderFns }